<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>냉장고 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div class="btn-frige-register" @click="createDevice">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>냉장고 등록</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>No.</th>
          <th>냉장고 ID</th>
          <th>냉장고 이름</th>
          <th>주소</th>
          <th>사업자</th>
          <th>운영자</th>
        </tr>

        <tbody v-if="loading === false && pagination.total > 0">
          <tr v-for="item in list" :key="item.deviceID" @click="goDetail(item)">
            <td class="text-center">
              <div>{{ item.num }}</div>
            </td>
            <td>
              <div>{{ item.deviceID }}</div>
            </td>
            <td>
              <div>{{ item.deviceName }}</div>
            </td>
            <td>
              <div>{{ item.address }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.deviceCompanyName }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination" v-if="pagination.total > 0">
        <span class="pagination-prev" @click="goPrev">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <span v-if="pagination.pageArray[0] > 1" @click="goPage(1)">1</span>
        <span v-if="pagination.pageArray[0] > 1" @click="jumpPrev">...</span>
        <span
          v-for="n in pagination.pageArray"
          :key="n"
          :class="n === pagination.page ? 'page-num current' : 'page-num'"
          @click="goPage(n)"
          >{{ n }}
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="jumpNext"
          >...
        </span>
        <span
          v-if="
            pagination.pageArray[pagination.pageArray.length - 1] <
            pagination.length
          "
          @click="goPage(pagination.length)"
          >{{ pagination.length }}
        </span>

        <span class="pagination-next" @click="goNext">
          <img src="/static/img/ico-arrow-line.png" alt />
        </span>

        <input
          type="number"
          v-model="pagination.input"
          @keyup.enter="goPage(Number(pagination.input))"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'company',
    'selectEvent',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    list: [],
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    downloading: false,
  }),
  watch: {
    selectEvent() {
      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;
      this.getList(false);
    },
  },
  created() {
    if (this.company) {
      this.loadPagination();
      this.getList(false);
    }
  },
  methods: {
    async getCount() {
      try {
        let countURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/count`;
        if (this.company) {
          countURL += `?companyID=${this.company.id}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          this.$emit('selectDevice', '');
          return this.pagination.total;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return this.pagination.total;
    },
    refreshList() {
      this.getList(false);
    },
    savePagination() {
      let key;
      if (this.company) {
        key = this.company.id;
      }
      const page = {
        [key]: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      let key;
      if (this.company) {
        key = this.company.id;
      }
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page[key] !== undefined) this.pagination.page = page[key];
    },
    async getList(forDownload) {
      this.savePagination();
      this.loading = true;
      const list = [];
      if (!forDownload) {
        this.list = [];
        this.pagination.input = this.pagination.page;
        await this.getCount();
      }

      /*
      if (!this.company) {
        return list;
      }
      */

      try {
        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;

        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/list?page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }`;
        if (this.company) {
          listURL += `&companyID=${this.company.id}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            this.$emit('selectDevice', '');
            return list;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        /* 소유회사, 부서, 사용자 정보 */
        await this.fetchCompanyList(resList.data.devices, 1);
        await this.fetchDivisionList(resList.data.devices, 1);
        await this.fetchUserList(resList.data.devices, 1);

        /* 운영회사, 부서, 사용자 정보 */
        await this.fetchCompanyList(resList.data.devices, 2);
        await this.fetchDivisionList(resList.data.devices, 2);
        await this.fetchUserList(resList.data.devices, 2);

        for (let i = 0; i < resList.data.devices.length; i++) {
          const p = resList.data.devices[i];

          if (this.division && p.divisionID !== this.division.id) continue;

          p.num = num;
          p.manufactureDate = this.$moment(p.manufactureAt).format('YYYY.MM.DD');
          // p.manufactureTime = this.$moment(p.manufactureAt).format('hh:mm A');
          p.manufactureTime = this.$moment(p.manufactureAt).format('HH:mm:ss');
          p.setupDate = this.$moment(p.setupAt).format('YYYY.MM.DD');
          // p.setupTime = this.$moment(p.setupAt).format('hh:mm A');
          p.setupTime = this.$moment(p.setupAt).format('HH:mm:ss');
          list.push(p);
          num--;
        }

        if (!forDownload) {
          this.list = list;
        }
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.list = [];
        this.loading = false;

        alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
      return list;
    },
    async fetchCompanyList(list, n) {
      const companyList = [];
      for (let i = 0; i < list.length; i++) {
        const ba = this.getCompanyData(list[i], n);
        companyList.push(ba);
      }

      return Promise.all(companyList);
    },
    async fetchDivisionList(list, n) {
      const divisionList = [];
      for (let i = 0; i < list.length; i++) {
        const ba = this.getDivisionData(list[i], n);
        divisionList.push(ba);
      }

      return Promise.all(divisionList);
    },
    async fetchUserList(list, n) {
      const userList = [];
      for (let i = 0; i < list.length; i++) {
        const ba = this.getUserData(list[i], n);
        userList.push(ba);
      }

      return Promise.all(userList);
    },
    async getCompanyData(value, n) {
      try {
        let companyID = null;

        if (n === 1) {
          companyID = value.companyID;
        } else {
          companyID = value.deviceCompanyID;
        }

        if (!companyID) {
          return;
        }

        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          if (n === 1) {
            value.companyName = response.data.company.companyName;
            value.companyAlias = response.data.company.companyAlias;
            value.registrationNo = response.data.company.registrationNo;
          } else {
            value.deviceCompanyName = response.data.company.companyName;
            value.deviceCompanyAlias = response.data.company.companyAlias;
            value.deviceRegistrationNo = response.data.company.registrationNo;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getDivisionData(value, n) {
      try {
        let divisionID = null;

        if (n === 1) {
          divisionID = value.divisionID;
        } else {
          divisionID = value.deviceDivisionID;
        }

        if (!divisionID) {
          return;
        }

        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${divisionID}?withUsers=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          if (n === 1) {
            value.divisionName = response.data.division.divisionName;
            value.divisionAlias = response.data.division.divisionAlias;
          } else {
            value.deviceDivisionName = response.data.division.divisionName;
            value.deviceDivisionAlias = response.data.division.divisionAlias;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserData(value, n) {
      try {
        let operatorUID = null;

        if (n === 1) {
          operatorUID = value.operatorUID;
        } else {
          operatorUID = value.deviceOperatorUID;
        }

        if (operatorUID) {
          const response = await this.$http.get(
            `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${operatorUID}`,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            },
          );
          if (response.data.resultCode === '0000') {
            if (n === 1) {
              value.operatorName = response.data.user.name;
              value.operatorID = response.data.user.userID;
            } else {
              value.deviceOperatorName = response.data.user.name;
              value.deviceOperatorID = response.data.user.userID;
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getList(false);
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getList(false);
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getList(false);
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getList(false);
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getList(false);
    },
    goDetail(device) {
      this.$emit('deviceDetail', device);
    },
    createDevice() {
      this.$emit('deviceCreate', this.company);
    },
    async downloadExcel() {
      try {
        this.downloading = true;
        const perPage = this.pagination.perPage;
        const page = this.pagination.page;
        const input = this.pagination.input;
        const total = this.pagination.total;
        const length = this.pagination.length;

        const devices = [];
        this.pagination.perPage = 500;
        for (this.pagination.page = 1; this.pagination.page < 500; this.pagination.page++) {
          const list = await this.getList(true);
          if (!list || list.length === 0) {
            break;
          }
          for (let j = 0; j < list.length; j++) {
            const it = list[j];
            const c = {
              deviceID: it.deviceID,
              deviceName: it.deviceName,
              address: it.address,
              place: it.place,
              manufactureDate: it.manufactureDate,
              manufactureTime: it.manufactureTime,
              setupDate: it.setupDate,
              setupTime: it.setupTime,
              ip: it.ip,
              port: it.port,
              companyName: it.companyName,
              divisionName: it.divisionName,
              operatorName: it.operatorName,
            };
            devices.push(c);
          }
        }
        this.pagination.perPage = perPage;
        this.pagination.page = page;
        this.pagination.input = input;
        this.pagination.total = total;
        this.pagination.length = length;

        if (devices.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return;
        }

        js2excel.json2excel({
          data: devices,
          name: 'cella-device',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.downloading = false;
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceList.vue